import React, { useState, useEffect } from "react";
import {
  Box,
  TextField,
  Typography,
  MenuItem,
  Button,
  Drawer,
  IconButton,
  Collapse,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Dialog,
  Tooltip,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { styled } from "@mui/material/styles";
import { api, get, post, put } from "../../../../utils/api";
import { fuelConsumptionUnits, FuelTypeEnum } from "../../../../utils/constant";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import DeleteIcon from "@mui/icons-material/Delete";
import EditDialog from "../../../../Components/Common/EditDialog";
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: "55%",
      overflowY: "auto",
    },
  },
};
function AddEquipment(props) {
  const [alreadyFacility, setAlreadyFacility] = useState(false);
  const [facilities, setFacilities] = useState(["Select"]); // Store list of facilities
  const [equipmentType, setEquipmentType] = useState(["Select"]); // Store list of facilities
  const [fuelType, setFuelType] = useState(["Select"]); // Store list of facilities
  const [unitConsumption, setUnitConsumption] = useState(["Select"]); // Store list of facilities
  const [deleteDialog, setDeleteDialog] = useState(false);
  const [deleteIndex, setDeleteIndex] = useState(null); // to track which equipment is being deleted
  const [industrialProcess, setIndustryProcess] = useState(["Select"]); // Store list of facilities

  const [equipments, setEquipments] = useState([]);
  const [noOfEquipment, setNoOfEquipment] = useState(0);
  const [UnitofFuelConsumption, setUnitofFuelConsumption] = useState();
  console.log("insidee", props);
  useEffect(() => {}, [deleteIndex]);

  useEffect(() => {
    if (props?.selectedEquipment) {
      setEquipments(props?.selectedEquipment?.equipments);
      setNoOfEquipment(props?.selectedEquipment?.noOfEquipment);
      setUnitofFuelConsumption(
        props?.selectedEquipment?.equipments[0]?.unitOfFuelConsumption
      );
    }
  }, [props]);
  const [editDialog, setEditDialog] = useState(false);
  const [formData2, setFormData2] = useState([]);

  // Dynamically toggle collapse for each equipment
  const [openMachines, setOpenMachines] = useState(
    new Array(equipments.length).fill(false)
  );
  const [showAddForm, setShowAddForm] = useState(false);
  const [newEquipmentType, setNewEquipmentType] = useState("");
  const initialState = {
    location: "",
    facility: "",
    industrialProcess: "",
    equipmentType: "",
    name: "",
    fuelType: "",
    noOfEquipment: "",
    remark: "",
    equipments: [],
  };

  const [errors, setErrors] = useState({});
  const [fromValue, setFromValue] = useState(initialState);
  console.log("fromValue", fromValue);

  useEffect(() => {
    fetchFacilities();
    const state = {
      location: props?.selectedEquipment?.location ?? "",
      facility: props?.selectedEquipment?.facility?._id ?? "",
      industrialProcess: props?.selectedEquipment?.industrialProcess?._id ?? "",
      equipmentType: props?.selectedEquipment?.equipmentType?._id ?? "",
      name: props?.selectedEquipment?.name ?? "",
      fuelType: props?.selectedEquipment?.fuelType ?? "",
      equipments: props?.selectedEquipment?.equipments ?? [],
      noOfEquipment: props?.selectedEquipment?.noOfEquipment ?? "",
      remark: props?.selectedEquipment?.remark ?? "",
    };
    setFromValue(state);
    setFormData2(state);
    setAlreadyFacility(props?.selectedEquipment === null ? false : true);
    setEquipments(props?.selectedEquipment?.equipments ?? []);
  }, [props.selectedEquipment]);

  useEffect(() => {
    setNoOfEquipment(equipments.length);
  }, [equipments]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    console.log("name1", name, value);

    // Update form value state
    setFromValue((prev) => ({
      ...prev,
      [name]: name === "noOfEquipment" ? Number(value) : value, // Ensure noOfEquipment is a number
    }));

    // Handle dynamic changes based on specific field names
    switch (name) {
      case "noOfEquipment": {
        const numOfForms = parseInt(value, 10);
        const unit =
          fromValue?.fuelType === "Natural Gas" ||
          fromValue?.fuelType === "Coal" 
            ? "Kg per hour"
            : ["Petroleum/Gasoline", "Diesel", "Fuel Oil", "LPG", "Propane"].includes(
                fromValue?.fuelType
              )
            ? "Ltr per hour"
            : "";

        const equipmentArray = Array.from({ length: numOfForms }, () => ({
          uniqueID: "",
          brand: "",
          model: "",
          ratedFuelConsumption: "",
          unitOfFuelConsumption: unit,
        }));

        setEquipments(equipmentArray);
        break;
      }

      case "fuelType": {
        const unit =
          value === "Natural Gas" || value === "Coal"
            ? "Kg per hour"
            : ["Petroleum/Gasoline", "Diesel", "Fuel Oil", "LPG", "Propane"].includes(value)
            ? "Ltr per hour"
            : "";

        setUnitofFuelConsumption(unit);

        // Update all equipment's unitOfFuelConsumption
        setEquipments((prevEquipments) =>
          prevEquipments.map((equipment) => ({
            ...equipment,
            unitOfFuelConsumption: unit,
          }))
        );

        // Clear unitOfFuelConsumption error if exists
        if (errors["unitOfFuelConsumption"]) {
          setErrors((prevErrors) => ({
            ...prevErrors,
            unitOfFuelConsumption: "", // Clear specific error
          }));
        }
        break;
      }

      case "equipmentType": {
        setShowAddForm(value === "other");
        break;
      }

      default:
        break;
    }

    // Clear errors for the specific field if they exist
    if (errors[name]) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: "", // Clear the specific field error
      }));
    }
  };

  console.log("sete", equipments);

  const handleDeleteAgree = () => {
    // if (selectedDeleteIndex !== null) {
    //   const updatedEquipments = equipments.filter((_, index) => index !== selectedDeleteIndex);
    //   setEquipments(updatedEquipments);
    //   setSelectedDeleteIndex(null);
    //   setNumberOfMachines(updatedEquipments.length);
    // }
    setEquipments((prevEquipments) => {
      const updatedEquipments = [...prevEquipments];
      updatedEquipments.splice(deleteIndex, 1);
      return updatedEquipments;
    });

    // Update the number of equipment
    setNoOfEquipment((prevCount) => prevCount - 1);

    // Optionally update the collapse state if needed
    setOpenMachines((prevOpenMachines) => {
      const updatedOpenMachines = [...prevOpenMachines];
      updatedOpenMachines.splice(deleteIndex, 1);
      return updatedOpenMachines;
    });
    setDeleteDialog(false);
    setDeleteIndex(null);
  };

  const handleAddClick = async () => {
    if (newEquipmentType.trim()) {
      try {
        const response = await post(`/master/addEquipmentType`, {
          name: newEquipmentType,
        });
        if (response?.data?.data) {
          // refreshEquipmentTypes(); // Refresh the equipment type options if needed
          setNewEquipmentType(""); // Clear input
          setShowAddForm(false); // Hide the form
          // fetchFacilities();
          getAllEQuipment();
          // props.setsnackOpen({
          //   open: true,
          //   message: "Equipment created successfully",
          //   severity: "success",
          // });
        }
      } catch (error) {
        props.setsnackOpen({
          open: true,
          message: "Equipment already exists",
          severity: "error",
        });
        setNewEquipmentType(""); // Clear input
        setShowAddForm(false);
      }
    }
  };

  const deleteEquipment = (index) => {
    setDeleteIndex(index);
    setDeleteDialog(true);
  };

  const toggleEquipment = (index) => {
    const updatedOpen = [...openMachines];
    updatedOpen[index] = !updatedOpen[index];
    setOpenMachines(updatedOpen); //
  };

  const handleFieldChange = (index, field, value) => {
    const updatedEquipments = [...equipments];
    updatedEquipments[index][field] = value;

    if (field === "ratedFuelConsumption") {
      // Allow only numeric values
      const numericValue = value.replace(/[^0-9.]/g, ""); // Only allow numbers and decimal point
      updatedEquipments[index][field] = numericValue;

      // Validate numeric input for the Rated Fuel Consumption
      if (
        numericValue.trim() === "" ||
        isNaN(numericValue) ||
        parseFloat(numericValue) <= 0
      ) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          [`equipment_${index}_ratedFuelConsumption`]: `Rated Fuel Consumption must be a valid positive number for Equipment ${
            index + 1
          }.`,
        }));
      } else {
        // Clear the specific field error if the input is valid
        setErrors((prevErrors) => ({
          ...prevErrors,
          [`equipment_${index}_ratedFuelConsumption`]: "",
        }));
      }
    } else {
      updatedEquipments[index][field] = value;

      // Clear the specific field error if it exists
      if (errors[`equipment_${index}_${field}`]) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          [`equipment_${index}_${field}`]: "", // Clear the specific field error
        }));
      }
    }

    setEquipments(updatedEquipments);
  };

  const addMoreEquipment = () => {
    const newEquipment = {
      uniqueID: "",
      brand: "",
      model: "",
      ratedFuelConsumption: "",
      unitOfFuelConsumption: UnitofFuelConsumption,
    };

    // Add new equipment and update state
    setEquipments((prevEquipments) => [...prevEquipments, newEquipment]);
    // Update the number of equipment
    setNoOfEquipment((prevCount) => prevCount + 1);
    // Update openMachines state to include a new entry
    setOpenMachines((prevOpenMachines) => [...prevOpenMachines, false]);
  };

  const getDropDownFieldId = (data) => {
    console.log("tres", data);
    if (typeof data === "string") {
      console.log("tres1");
      return data; // If it's a direct ID, return it
    }
    return data?._id || ""; // If it's an object, return the _id
  };

  const fetchFacilities = async () => {
    try {
      let response = await get("/master/getAllFacility");

      const equipmentTypeResponse = await get("/master/getAllEquipmentType");

      setFacilities(response.data.data);
      setEquipmentType(equipmentTypeResponse.data.data);
      setFuelType(FuelTypeEnum);
      setUnitConsumption(fuelConsumptionUnits);
    } catch (error) {
      console.log("Error fetching facilities:", error);
    }
  };

  const getAllEQuipment = async () => {
    try {
      const equipmentTypeResponse = await get(`/master/getAllEquipmentType`);
      setEquipmentType(equipmentTypeResponse.data.data);
    } catch (error) {
      console.log("Error fetching facilities:", error);
    }
  };

  useEffect(() => {
    getAllIndustryProcess();
  }, []);

  const getAllIndustryProcess = async () => {
    try {
      const equipmentTypeResponse = await get(
        `/master/getAllIndustrialProcess`
      );
      console.log(equipmentTypeResponse.data.data, "d1");
      setIndustryProcess(equipmentTypeResponse.data.data);
    } catch (error) {
      console.log("Error fetching facilities:", error);
    }
  };

  const Save = async () => {
    if (!validateForm()) {
      return;
    }
    try {
      const updatedNoOfEquipment = equipments.length;
      const dataToSubmit = {
        ...fromValue,
        equipments: equipments,
        noOfEquipment: updatedNoOfEquipment,
      };

      const url = alreadyFacility
        ? `${api}/master/updateIndustrialEquipment?id=${props.selectedEquipment?._id}`
        : `${api}/master/addIndustrialEquipment`;

      const response = alreadyFacility
        ? await put(url, dataToSubmit)
        : await post(url, dataToSubmit);

      handleExitAgree();
      props.setAddFacility(false);
      props.setsnackOpen({
        open: true,
        message: response?.data?.message,
        severity: "success",
      });
      props.fetchFacilities();
      console.log(response);
    } catch (err) {
      console.log(err);
      // if (err?.response?.data?.message) {
      //   if (err?.response?.data?.statusCode === 0) {
      //     setErrors((prevErrors) => ({
      //       ...prevErrors,
      //       name: "Industrial Equipment Already exists.",
      //     }));
      //   } else {
      //     props.setsnackOpen({
      //       open: true,
      //       message: err.response.data.message,
      //       severity: "error",
      //     });
      //   }
      // }
      props.setsnackOpen({
        open: true,
        message:
          err?.response?.data?.message || "An error occurred while saving data",
        severity: "error",
      });
    }
  };

  const validateForm = () => {
    const newErrors = {};
    const { location, facility, equipmentType, name, fuelType, noOfEquipment } =
      fromValue;

    // Validate main fields
    if (!location || location.trim() === "") {
      newErrors.location = "Location is required.";
    }

    // if (!facility || facility === "Select") {
    //   newErrors.facility = "Please select a facility.";
    // }

    if (
      !equipmentType ||
      equipmentType === "Select" ||
      equipmentType === "other"
    ) {
      newErrors.equipmentType = "Please select an equipment type.";
    }

    if (!name || name.trim() === "") {
      newErrors.name = "Equipment name is required.";
    }

    if (!fuelType || fuelType.trim() === "") {
      newErrors.fuelType = "Fuel type is required.";
      newErrors.unitOfFuelConsumption = "Unit Of Fuel Consumption is required.";
    }

    if (
      (!noOfEquipment ||
        isNaN(noOfEquipment) ||
        parseInt(noOfEquipment) <= 0) &&
      equipments.length === 0
    ) {
      newErrors.noOfEquipment = "Number of equipment must be a valid number.";
    } else if (equipments.length === 0) {
      newErrors.noOfEquipment = "Number of equipment must be a valid number.";
    }

    // Validate each equipment form
    equipments.forEach((equipment, index) => {
      if (!equipment.uniqueID || equipment.uniqueID.trim() === "") {
        newErrors[
          `equipment_${index}_uniqueID`
        ] = `Unique ID is required for Equipment ${index + 1}.`;
      }
      if (!equipment.brand || equipment.brand.trim() === "") {
        newErrors[
          `equipment_${index}_brand`
        ] = `Brand is required for Equipment ${index + 1}.`;
      }
      if (!equipment.model || equipment.model.trim() === "") {
        newErrors[
          `equipment_${index}_model`
        ] = `Model is required for Equipment ${index + 1}.`;
      }
      if (
        !equipment.ratedFuelConsumption ||
        equipment.ratedFuelConsumption.trim() === ""
      ) {
        newErrors[
          `equipment_${index}_ratedFuelConsumption`
        ] = `Rated Fuel Consumption is required for Equipment ${index + 1}.`;
      }
      // if (
      //   !equipment.unitOfFuelConsumption ||
      //   equipment.unitOfFuelConsumption.trim() === ""
      // ) {
      //   newErrors[
      //     `equipment_${index}_unitOfFuelConsumption`
      //   ] = `Unit of Fuel Consumption is required for Equipment ${index + 1}.`;
      // }
    });

    // Check for duplicate unique IDs
    const uniqueIds = equipments.map((equipment) => equipment.uniqueID);
    uniqueIds.forEach((id, idx) => {
      if (uniqueIds.indexOf(id) !== idx) {
        newErrors[`equipment_${idx}_uniqueID`] = "Unique ID must be unique.";
      }
    });

    console.log("newErrors: " + newErrors);

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleClose = () => {
    const isFormDataUnchanged = Object.keys(fromValue).every(
      (key) => fromValue[key] === formData2[key]
    );

    if (isFormDataUnchanged) {
      handleExitAgree();
    } else {
      setEditDialog(true);
    }
  };

  const handleExitAgree = () => {
    setFromValue(
      props.selectedEquipment === null ? initialState : props.selectedFacility
    );
    props.setAddFacility(false);
    props.fetchFacilities();
    setFormData2(
      props.selectedEquipment === null ? initialState : props.selectedFacility
    );
    setEquipments([]); // Reset equipments
    setNoOfEquipment(null); // Reset number of equipment
    setOpenMachines([]); // Reset open machines state if necessary
    setErrors({}); // Clear any existing errors
    setAlreadyFacility(false);
    setShowAddForm(false);
    setNewEquipmentType("");
    setUnitofFuelConsumption();
    setEditDialog(false);
    // setFromValue({});
  };

  const list = () => (
    <Box
      display="flex"
      gap={3}
      sx={{
        width: "26.5rem",
        maxWidth: "100%",
        // width: 400,
        // maxWidth:"100%",
        height: "100vh",
        display: "flex",
        justifyContent: "space-btween",
        backgroundColor: "transparent",
      }}
    >
      {console.log("list", props?.selectedEquipment?._id)}
      {editDialog && (
        <EditDialog {...{ editDialog, setEditDialog, handleExitAgree }} />
      )}
      <Box
        sx={{
          backgroundColor: "#fff",
          height: "3%",
          padding: "13px",
          margin: "30px 0 0 0",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          borderRadius: "80%",
          width: "5%",
        }}
      >
        <IconButton
          onClick={() => {
            handleClose();
          }}
          sx={{ color: "black" }}
        >
          <CloseIcon sx={{ fontSize: "1.2rem" }} />
        </IconButton>
      </Box>
      <Box
        sx={{
          padding: "24px",
          backgroundColor: "#fff",
          height: "100%",
          width: "100%",
          overflowY: "scroll",
        }}
      >
        <Typography
          variant="h6"
          sx={{
            textDecoration: "underline",
            fontWeight: "bold",

            mb: 2,
          }}
        >
          {props?.selectedEquipment?._id === undefined
            ? "Add Industrial Equipment"
            : "Edit Industrial Equipment"}
        </Typography>

        <Typography variant="subtitle1" sx={{ fontWeight: "bold", mt: 1 }}>
          Location
        </Typography>

        <CustomTextField
          //   select
          variant="outlined"
          value={fromValue?.location}
          onChange={handleChange}
          fullWidth
          name="location"
          placeholder="Enter Name"
          error={!!errors?.location} // Show error styling if there's an error
          InputLabelProps={{
            style: { color: errors.location ? "#D34040" : undefined },
          }}
          disabled={
            props.selectedEquipment?.location === undefined ? false : true
          }
        ></CustomTextField>
        {errors.location && (
          <Typography variant="body2" color="#D34040">
            {errors.location}
          </Typography>
        )}

        <Typography variant="subtitle1" sx={{ fontWeight: "bold", mt: 1 }}>
          Industrial Process
        </Typography>
        <CustomTextField
          select
          variant="outlined"
          value={
            fromValue?.industrialProcess === "" || undefined
              ? "Tap to Select"
              : getDropDownFieldId(fromValue?.industrialProcess)
          }
          onChange={handleChange}
          fullWidth
          name="industrialProcess"
          placeholder="Tap to Select"
          error={!!errors.industrialProcess} // Show error styling if there's an error
          InputLabelProps={{
            style: { color: errors.industrialProcess ? "#D34040" : undefined },
          }}
          SelectProps={{ MenuProps }}
          disabled={
            props.selectedEquipment?.industrialProcess === undefined
              ? false
              : true
          }
        >
          <MenuItem
            value={
              fromValue?.industrialProcess === "" || undefined
                ? "Tap to Select"
                : fromValue?.industrialProcess
            }
            disabled
          >
            {fromValue?.industrialProcess === "" || undefined
              ? "Tap to Select"
              : fromValue?.industrialProcess?.industryProcess}
          </MenuItem>{" "}
          {industrialProcess?.map((item, i) => (
            <MenuItem
              key={i}
              value={item._id}
              sx={{
                maxWidth: "289px", // Ensure a fixed width
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                display: "block", // Ensure block layout
              }}
            >
              {item.industryProcess}
            </MenuItem>
          ))}
        </CustomTextField>

        <Typography variant="subtitle1" sx={{ fontWeight: "bold", mt: 1 }}>
          Equipment Type
        </Typography>
        <CustomTextField
          select
          variant="outlined"
          value={
            fromValue?.equipmentType === "" || undefined
              ? "Tap to Select"
              : getDropDownFieldId(fromValue?.equipmentType)
          }
          onChange={handleChange}
          fullWidth
          name="equipmentType"
          placeholder="Tap to Select"
          error={!!errors.equipmentType} // Show error styling if there's an error
          InputLabelProps={{
            style: { color: errors.equipmentType ? "#D34040" : undefined },
          }}
          SelectProps={{ MenuProps }}
          disabled={
            props.selectedEquipment?.equipmentType === undefined ? false : true
          }
        >
          <MenuItem
            value={
              fromValue?.equipmentType === "" || undefined
                ? "Tap to Select"
                : fromValue?.equipmentType
            }
            disabled
          >
            {fromValue?.equipmentType === "" || undefined
              ? "Tap to Select"
              : fromValue?.equipmentType?.name}
          </MenuItem>{" "}
          {equipmentType?.map((item, i) => (
            // <Tooltip key={i} title={item.name} placement="top" arrow>
            <MenuItem
              key={i}
              value={item._id}
              sx={{
                maxWidth: "289px",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                display: "block",
              }}
            >
              {item.name}
            </MenuItem>
            // </Tooltip>
          ))}
          <MenuItem onClick={() => setShowAddForm(true)} value="other">
            Other
          </MenuItem>
        </CustomTextField>
        {showAddForm && (
          <Box sx={{ mt: 1 }}>
            <CustomTextField
              variant="outlined"
              fullWidth
              placeholder="Enter name"
              value={newEquipmentType}
              onChange={(e) => setNewEquipmentType(e.target.value)}
            />

            <Button
              variant="contained"
              sx={{
                backgroundColor: "#0a3f73",
                textTransform: "none",
                marginTop: "3%",
              }}
              onClick={handleAddClick}
            >
              Add
            </Button>
          </Box>
        )}
        {errors.equipmentType && (
          <Typography variant="body2" color="#D34040">
            {errors.equipmentType}
          </Typography>
        )}
        <Typography variant="subtitle1" sx={{ fontWeight: "bold", mt: 1 }}>
          Equipment Name
        </Typography>

        <CustomTextField
          //  select
          variant="outlined"
          value={fromValue?.name}
          onChange={handleChange}
          fullWidth
          name="name"
          placeholder="Enter name"
          error={!!errors.name} // Show error styling if there's an error
          InputLabelProps={{
            style: { color: errors.name ? "#D34040" : undefined },
          }}
          disabled={props?.selectedEquipment?.name === undefined ? false : true}
        ></CustomTextField>
        {errors.name && (
          <Typography variant="body2" color="#D34040">
            {errors.name}
          </Typography>
        )}
        <Typography variant="subtitle1" sx={{ fontWeight: "bold", mt: 1 }}>
          Fuel type
        </Typography>
        <CustomTextField
          select
          variant="outlined"
          fullWidth
          name="fuelType"
          value={
            fromValue?.fuelType === "" || undefined
              ? "Tap to Select"
              : fromValue?.fuelType
          } // Set empty string as default if no value is selected
          onChange={handleChange}
          placeholder="Select fuel type"
          error={!!errors.fuelType}
          InputLabelProps={{
            style: { color: errors.fuelType ? "#D34040" : undefined },
          }}
          SelectProps={{ MenuProps }}
          disabled={
            props.selectedEquipment?.fuelType === undefined ? false : true
          }
        >
          {/* Disabled option as the default prompt */}
          <MenuItem
            value={
              fromValue?.fuelType === "" || undefined
                ? "Tap to Select"
                : fromValue?.fuelType
            }
            disabled
          >
            Tap to Select
          </MenuItem>

          {/* Map through FuelTypeEnum for dropdown options */}
          {fuelType.map((item, index) => (
            <MenuItem key={`fuelType__${item}${index}`} value={item}>
              {item}
            </MenuItem>
          ))}
        </CustomTextField>
        {errors.fuelType && (
          <Typography variant="body2" color="#D34040">
            {errors.fuelType}
          </Typography>
        )}

        <Typography variant="subtitle1" sx={{ fontWeight: "bold", mt: 1 }}>
          No of Equipment
        </Typography>

        <CustomTextField
          //  select
          disabled={alreadyFacility} // Disable if editing an existing facility
          variant="outlined"
          // value={fromValue.noOfEquipment}
          value={noOfEquipment || ""}
          onChange={(e) => {
            setNoOfEquipment(Number(e.target.value));
            handleChange(e);
          }}
          fullWidth
          name="noOfEquipment"
          placeholder="Enter No of Equipment"
          error={!!errors.noOfEquipment}
          InputLabelProps={{
            style: { color: errors.noOfEquipment ? "#D34040" : undefined },
          }}
        ></CustomTextField>
        <br />
        {errors.noOfEquipment && (
          <Typography variant="body2" color="#D34040">
            {errors.noOfEquipment}
          </Typography>
        )}

        <Dialog
          open={deleteDialog}
          onClose={() => setDeleteDialog(false)}
          BackdropProps={{
            style: {
              backgroundColor: "rgba(0, 0, 0, 0.02)", // Adjust the opacity as needed (0.3 is lighter)
            },
          }}
        >
          <DialogTitle>Confirm Delete</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Do you really want to delete this entry?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setDeleteDialog(false)} color="primary">
              Cancel
            </Button>
            {/* onClick={() => deleteEquipment(index)} */}
            <Button onClick={handleDeleteAgree} color="secondary">
              Confirm
            </Button>
          </DialogActions>
        </Dialog>
        {/* Dynamically Render Equipment Forms */}
        {equipments.length > 0 &&
          equipments.map((equipment, index) => (
            <Box key={index} sx={{ mt: 2 }}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Typography
                  variant="h6"
                  sx={{ fontSize: "16px", fontWeight: "bold" }}
                >
                  Equipment {index + 1}
                </Typography>

                <Box>
                  <IconButton onClick={() => toggleEquipment(index)}>
                    {openMachines[index] ? (
                      <ArrowDropUpIcon />
                    ) : (
                      <ArrowDropDownIcon />
                    )}
                  </IconButton>

                  <IconButton
                    onClick={() => deleteEquipment(index)}
                    color="error"
                  >
                    <DeleteIcon />
                  </IconButton>
                </Box>
              </Box>
              {errors[`equipment_${index}_brand`] && (
                <Typography variant="body2" color="#D34040">
                  {`Please fill Equipment ${index + 1} form`}
                </Typography>
              )}

              <Collapse in={openMachines[index]} timeout="auto" unmountOnExit>
                <Box sx={{ mt: 1 }}>
                  <Typography
                    variant="subtitle1"
                    sx={{ fontWeight: "bold", mt: 1 }}
                  >
                    Unique ID
                  </Typography>
                  <CustomTextField
                    variant="outlined"
                    value={equipment.uniqueID}
                    placeholder="Enter ID"
                    fullWidth
                    onChange={(e) =>
                      handleFieldChange(index, "uniqueID", e.target.value)
                    }
                  />
                  {errors[`equipment_${index}_uniqueID`] && (
                    <Typography variant="body2" color="#D34040">
                      {errors[`equipment_${index}_uniqueID`]}
                    </Typography>
                  )}
                  <Typography
                    variant="subtitle1"
                    sx={{ fontWeight: "bold", mt: 1 }}
                  >
                    Brand
                  </Typography>
                  <CustomTextField
                    variant="outlined"
                    value={equipment.brand}
                    placeholder="Enter Brand"
                    fullWidth
                    onChange={(e) =>
                      handleFieldChange(index, "brand", e.target.value)
                    }
                  />
                  {errors[`equipment_${index}_brand`] && (
                    <Typography variant="body2" color="#D34040">
                      {errors[`equipment_${index}_brand`]}
                    </Typography>
                  )}
                  <Typography
                    variant="subtitle1"
                    sx={{ fontWeight: "bold", mt: 1 }}
                  >
                    Model
                  </Typography>
                  <CustomTextField
                    variant="outlined"
                    value={equipment.model}
                    placeholder="Enter Model"
                    fullWidth
                    onChange={(e) =>
                      handleFieldChange(index, "model", e.target.value)
                    }
                    // error={!!errors[`equipment_${index}_model`]}
                    // helperText={errors[`equipment_${index}_model`]}
                  />
                  {errors[`equipment_${index}_model`] && (
                    <Typography variant="body2" color="#D34040">
                      {errors[`equipment_${index}_model`]}
                    </Typography>
                  )}
                  <Typography
                    variant="subtitle1"
                    sx={{ fontWeight: "bold", mt: 1 }}
                  >
                    Rated Fuel Consumption
                  </Typography>
                  <CustomTextField
                    variant="outlined"
                    value={equipment.ratedFuelConsumption}
                    placeholder="Amount"
                    fullWidth
                    onChange={(e) =>
                      handleFieldChange(
                        index,
                        "ratedFuelConsumption",
                        e.target.value
                      )
                    }
                  />
                  {errors[`equipment_${index}_ratedFuelConsumption`] && (
                    <Typography variant="body2" color="#D34040">
                      {errors[`equipment_${index}_ratedFuelConsumption`]}
                    </Typography>
                  )}

                  <Typography
                    variant="subtitle1"
                    sx={{ fontWeight: "bold", mt: 1 }}
                  >
                    Unit of Fuel Consumption
                  </Typography>

                  <CustomTextField
                    variant="outlined"
                    value={UnitofFuelConsumption}
                    placeholder="Unit of Fuel consumption"
                    fullWidth
                    disabled={true}
                    error={!!errors.unitOfFuelConsumption}
                    InputLabelProps={{
                      style: {
                        color: errors.unitOfFuelConsumption
                          ? "#D34040"
                          : undefined,
                      },
                    }}
                  />
                  {/* 
        ></CustomTextField> */}
                  <br />
                  {errors.unitOfFuelConsumption && (
                    <Typography variant="body2" color="#D34040">
                      {errors.unitOfFuelConsumption}
                    </Typography>
                  )}

                  {/* <CustomTextField
                    select
                    variant="outlined"
                    fullWidth
                    value={
                      equipment.unitOfFuelConsumption === "" || undefined
                        ? "Tap to Select"
                        : equipment.unitOfFuelConsumption
                    }
                    // value={equipment.unitOfFuelConsumption || "Tap to Select"}
                    onChange={(e) =>
                      handleFieldChange(
                        index,
                        "unitOfFuelConsumption",
                        e.target.value
                      )
                    }
                    placeholder="Tap to Select"
                    error={!!errors[`equipment_${index}_unitOfFuelConsumption`]}
                    InputLabelProps={{
                      style: {
                        color: errors[
                          `equipment_${index}_unitOfFuelConsumption`
                        ]
                          ? "#D34040"
                          : undefined,
                      },
                    }}
                  >
                    <MenuItem
                      value={
                        equipment?.unitOfFuelConsumption === "" || undefined
                          ? "Tap to Select"
                          : equipment.unitOfFuelConsumption
                      }
                      disabled
                    >
                      Tap to Select
                    </MenuItem>

                    {unitConsumption.map((item, index) => (
                      <MenuItem
                        key={`unitConsumption__${item}${index}`}
                        value={item}
                        sx={{
                          "&:hover": {
                            backgroundColor: "#f5f5f5",
                          },
                          padding: "10px 20px",
                          borderRadius: "4px",
                        }}
                      >
                        {item} 
                      </MenuItem>
                    ))}
                  </CustomTextField>
                  {errors[`equipment_${index}_unitOfFuelConsumption`] && (
                    <Typography variant="body2" color="#D34040">
                      {errors[`equipment_${index}_unitOfFuelConsumption`]}
                    </Typography>
                  )} */}
                </Box>
              </Collapse>
            </Box>
          ))}

        {alreadyFacility && (
          <Button
            onClick={addMoreEquipment}
            variant="contained"
            sx={{ mt: 2, backgroundColor: "#0a3f73" }}
          >
            Add Equipment
          </Button>
        )}

        <Typography variant="subtitle1" sx={{ fontWeight: "bold", mt: 1 }}>
          Remark
        </Typography>

        <TextField
          multiline
          rows={2}
          variant="outlined"
          fullWidth
          name="remark"
          value={fromValue?.remark}
          onChange={handleChange}
          placeholder="Brief"
        />
        {errors.incharge && (
          <Typography variant="body2" color="#D34040">
            {errors.incharge}
          </Typography>
        )}

        {/* <Box> */}
        <Button
          variant="contained"
          sx={{
            backgroundColor: "#0a3f73",
            textTransform: "none",
            marginTop: "10%",
          }}
          onClick={Save}
        >
          Submit
        </Button>
        {/* </Box> */}
      </Box>
    </Box>
  );

  return (
    <div style={{ zIndex: 2000 }}>
      <Drawer
        sx={{
          backgroundColor: "transparent",
          "& .MuiDrawer-paper": {
            backgroundColor: "transparent", // Make paper transparent
            boxShadow: "none", // Optional: Remove any shadow
          },
        }}
        anchor="right"
        open={props.addFacility}
        onClose={() => {
          handleClose();
        }}
      >
        {list()}
      </Drawer>
    </div>
  );
}

export default AddEquipment;

//// custom textfield

const CustomTextField = styled(TextField)(({ theme }) => ({
  "& .MuiInputBase-root": {
    height: "40px", // Adjust height as needed
  },
  "& .MuiSelect-select": {
    height: "56px", // Adjust height as needed
    display: "flex",
    alignItems: "center",
  },
}));
